export default __webpack_public_path__ + "static/media/404.458d53b3.jpg";